import React, { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
//import "./App.css";
// import Info from "./Components/info";
import LinearIndeterminate from "./Components/loading.js";
import ChatWrapper from "./Components/LiveChat/ChatWrapper";
import CookieBanner from "./Components/CookieBanner";
import { OnlineStatusProvider } from "./contexts/OnlineStatusContext";
import { TransactionProvider } from "./contexts/TransactionContext";

import { BrowserRouter as Router1, Switch, Route } from "react-router-dom";

// import HomePage from "./Components/HomePage";
import RealHomePage from "./Components/RealHomePage";
//import NewPage from "./Components/newPage";
// login may also not need lazy loading
import Login from "./Components/Login";
import ContactPage from "./Components/ContactPage";
import About from "./Components/About";
//import Logout from "./Components/Logout";
import { FirebaseAuth } from "./Components/context";
import PrivateRoutes from "./Components/PrivateRoutes";
import ErrorFallback from "./Components/ErrorFallback.js";

import TransitionsModal from "./Components/MaterialUIModal";
import UsageInfo from "./Components/UsageInfo.js";
import { ReRoute } from "./Components/ReRoute.js";
import Pricing from "./Components/Pricing.js";
import AccountingMaterial from "./Components/AccountingMaterial.js";

// lazy loading for improved loading performance and is used with suspense to allow loading/fallback content
const SOCI = React.lazy(() => import("./Components/soCI.jsx"));
const TermsAndConditions = React.lazy(
  () => import("./Components/TermsAndConditions.js"),
);
const FeedBack = React.lazy(() => import("./Components/FeedBack.js"));
const FeedbackPage = React.lazy(() => import("./Components/FeedbackPage.js"));
const Admin = React.lazy(() => import("./Components/Admin.js"));
const AdminInfo = React.lazy(() => import("./Components/AdminInfo.js"));
const AdminDashboard = React.lazy(
  () => import("./Components/AdminDashboard.jsx"),
);
const ClientMessages = React.lazy(
  () => import("./Components/ClientMessages.jsx"),
);

const BankUpdate = React.lazy(() => import("./Components/bankUpdate.js"));
const ErrorHandlingTest = React.lazy(
  () => import("./Components/ErrorHandlingTest.jsx"),
);

const Directory = React.lazy(() => import("./Components/Directory.js"));
const UserProfile = React.lazy(() => import("./Components/UserProfile.js"));
const AuditLogs = React.lazy(() => import("./Components/AuditLogs.js"));
const Signup = React.lazy(() => import("./Components/Signup.js"));
const ResetPasscode = React.lazy(() => import("./Components/ResetPasscode.js"));
const Accounts = React.lazy(() => import("./Components/Accounts.jsx"));
const AccountsApple = React.lazy(
  () => import("./Components/Accounts_Apple.jsx"),
);
const OpeningBalances = React.lazy(
  () => import("./Components/OpeningBalances.js"),
);
const AfterLoginPage = React.lazy(() => import("./Components/AfterLoginPage"));
const Tasks = React.lazy(() => import("./Components/Tasks"));
const TasksPage = React.lazy(() => import("./Components/TasksPage"));
const TasksDetails = React.lazy(() => import("./Components/TasksDetails"));
const TasksAdded = React.lazy(() => import("./Components/TasksAdded"));
const TaskSummary = React.lazy(() => import("./Components/TaskSummary"));
const CipcApproval = React.lazy(() => import("./Components/CipcApproval"));
const CIPCTracking = React.lazy(() => import("./Components/CIPCTracking"));
//const About = React.lazy(() => import("./Components/About"));
const SignUpAndAddUser = React.lazy(
  () => import("./Components/signUpAndAddUser"),
);
const AddClientCompany = React.lazy(
  () => import("./Components/AddClientCompany"),
);
const ProvTax = React.lazy(() => import("./Components/ProvTax"));
const Journal = React.lazy(() => import("./Components/journal"));
const SoFP = React.lazy(() => import("./Components/soFP"));
const Notes = React.lazy(() => import("./Components/notes.jsx"));
const NotesMenuPage = React.lazy(
  () => import("./Components/NotesMenuPage.jsx"),
);
const CashFlow = React.lazy(() => import("./Components/cashflow"));
const SoCE = React.lazy(() => import("./Components/soCE"));
const TBalance = React.lazy(() => import("./Components/TBalance"));
const TBalanceOptimized = React.lazy(
  () => import("./Components/TBalanceOptimized.js"),
);
const TaxNavigation = React.lazy(() => import("./Components/TaxNavigation"));
const VatCalculation = React.lazy(() => import("./Components/VatCalculation"));
const DeveloperPortal = React.lazy(
  () => import("./Components/DeveloperPortal"),
);
const PdfDisplay = React.lazy(() => import("./Components/PdfDisplay.js"));
const NoteSelected = React.lazy(() => import("./Components/NoteSelected.js"));
const CustomerAgingReport = React.lazy(
  () => import("./Components/CustomerAgingReport.js"),
);
const SupplierAgingReport = React.lazy(
  () => import("./Components/SupplierAgingReport.js"),
);

const Cover = React.lazy(() => import("./Components/cover.jsx"));

// 🧪 TESTING: Optimized Ledger Versions (Remove these after testing)
const LedgerTester = React.lazy(() => import("./Components/LedgerTester.js"));
const LedgerSimple = React.lazy(
  () => import("./Components/LedgerOptimizedSimple.js"),
);
const LedgerAdvanced = React.lazy(
  () => import("./Components/LedgerOptimized.js"),
);
const SystemHealthCheck = React.lazy(
  () => import("./Components/SystemHealthCheck.js"),
);
const AccountantsReport = React.lazy(() => import("./Components/report.jsx"));
const Dashboard = React.lazy(() => import("./Components/Dashboard.js"));
const Budget = React.lazy(() => import("./Components/Budget.js"));
const Tutorial = React.lazy(() => import("./Components/Tutorial.js"));
const TutorialNew = React.lazy(() => import("./Components/TutorialNew.js"));

const SettingsFile = React.lazy(() => import("./Components/settings.js"));
const CompliancePortal = React.lazy(
  () => import("./Components/CompliancePortal.js"),
);
const Contents = React.lazy(() => import("./Components/contents.jsx"));
const TaxCalc = React.lazy(() => import("./Components/TaxCalc.js"));
const AddEmployee = React.lazy(() => import("./Components/AddEmployee.js"));
const ExportData = React.lazy(() => import("./Components/ExportData.js"));
const EmployerDetails = React.lazy(
  () => import("./Components/EmployerDetails.js"),
);
const AutomateAccount = React.lazy(
  () => import("./Components/AutomateAccount.js"),
);
const Payments = React.lazy(() => import("./Components/Payment.js"));
const PayrollTotal = React.lazy(() => import("./Components/PayrollTotal.js"));
const PayrollDashboard = React.lazy(
  () => import("./Components/PayrollDashboard.js"),
);
const LeaveManagement = React.lazy(
  () => import("./Components/LeaveManagement.js"),
);
const EMP201Report = React.lazy(() => import("./Components/EMP201Report.js"));
const EmployeePortal = React.lazy(
  () => import("./Components/EmployeePortal.js"),
);
const Invoices = React.lazy(() => import("./Components/Invoices.js"));
const InvoicesAdded = React.lazy(() => import("./Components/InvoicesAdded.js"));
const InvoicesPage = React.lazy(() => import("./Components/InvoicesPage.js"));
const Support = React.lazy(() => import("./Components/Support.js"));
const AdminChat = React.lazy(
  () => import("./Components/LiveChat/AdminChat.js"),
);
const AdminUpdates = React.lazy(() => import("./Components/AdminUpdates.jsx"));
const UpdatesPage = React.lazy(() => import("./Components/UpdatesPage.jsx"));
const ChatDemo = React.lazy(() => import("./Components/LiveChat/ChatDemo.js"));
const ShortCut = React.lazy(() => import("./Components/ShortCut.js"));
const ExtractData = React.lazy(() => import("./Components/ExtractData.js"));
const Businesses = React.lazy(() => import("./Components/Businesses.js"));
const AddBusiness = React.lazy(() => import("./Components/AddBusiness.js"));
const AddProduct = React.lazy(() => import("./Components/AddProduct.js"));
const ProductsAdded = React.lazy(() => import("./Components/ProductsAdded.js"));
const ProvTaxCalc = React.lazy(() => import("./Components/ProvTaxCalc.js"));
const AssetRegister = React.lazy(() => import("./Components/AssetRegister.js"));
const InvoiceSummary = React.lazy(
  () => import("./Components/InvoiceSummary.js"),
);
const InvoicePayment = React.lazy(
  () => import("./Components/InvoicePayment.js"),
);
const InvestecAPI = React.lazy(() => import("./Components/InvestecAPI.js"));
const BulkImport = React.lazy(() => import("./Components/BulkImport.js"));
const UploadProducts = React.lazy(
  () => import("./Components/UploadProducts.js"),
);
const AccountingSoftwareImport = React.lazy(
  () => import("./Components/AccountingSoftwareImport.js"),
);
const Internal = React.lazy(() => import("./Components/Internal.js"));
const ClientCollaboration = React.lazy(
  () => import("./Components/ClientCollaboration.js"),
);
const InventoryManagement = React.lazy(
  () => import("./Components/InventoryManagement.js"),
);
const AuditPortal = React.lazy(() => import("./Components/AuditPortal.js"));
const MigrationOnboarding = React.lazy(
  () => import("./Components/MigrationOnboarding.js"),
);
const EngagementLetters = React.lazy(
  () => import("./Components/EngagementLetters.js"),
);
const EngagementPortal = React.lazy(
  () => import("./Components/EngagementPortal.js"),
);

const PageNotFound = React.lazy(() => import("./Components/pagenotfound.jsx"));
// const GiveUserAccess = React.lazy(() =>
//   import("./Components/GiveUserAccess.js")
// );

function App() {
  return (
    <OnlineStatusProvider>
      <TransactionProvider>
        <Router1>
          <div className="App">
            <header className="App-header">
              {/* FirebaseAuth allows private components to access functions */}
              <FirebaseAuth>
                <ReRoute>
                  {/* shown when the component is loaded, as it its not already loaded as previous. */}
                  <Suspense fallback={<LinearIndeterminate />}>
                    <Switch>
                      <ErrorBoundary FallbackComponent={ErrorFallback}>
                        {/* RealHomePage doesnt need to be lazy loaded, as users may land on this page */}
                        <Route exact path="/" component={RealHomePage} />
                        <Route exact path="/CipcApproval" component={CipcApproval} />

                        <PrivateRoutes
                          path="/AfterLoginPage"
                          component={AfterLoginPage}
                        />

                        <Route path="/Signup" component={Signup}></Route>
                        <Route
                          path="/ContactPage"
                          component={ContactPage}
                        ></Route>
                        <Route
                          path="/TermsAndConditions"
                          component={TermsAndConditions}
                        ></Route>

                        <Route path="/Login">
                          {" "}
                          <Login />
                        </Route>
                        <Route path="/About" component={About} />
                        <Route path="/Pricing" component={Pricing} />
                        <Route
                          path="/accountingmaterial"
                          component={AccountingMaterial}
                        />
                        <Route path="/UsageInfo" component={UsageInfo} />
                        <PrivateRoutes
                          path="/Directory"
                          component={Directory}
                        />
                        <PrivateRoutes
                          path="/AddClientCompany"
                          component={AddClientCompany}
                        />

                        <PrivateRoutes
                          path="/signUpAndAddUser"
                          component={SignUpAndAddUser}
                        />

                        <PrivateRoutes path="/soCI" component={SOCI} />
                        <PrivateRoutes path="/Accounts" component={Accounts} />
                        <PrivateRoutes
                          path="/AccountsApple"
                          component={AccountsApple}
                        />
                        <PrivateRoutes path="/soFP" component={SoFP} />
                        <PrivateRoutes path="/soCE" component={SoCE} />
                        <PrivateRoutes path="/notes" component={Notes} />
                        <PrivateRoutes path="/cashflow" component={CashFlow} />
                        <PrivateRoutes path="/journals" component={Journal} />
                        <PrivateRoutes path="/ProvTax" component={ProvTax} />
                        <PrivateRoutes
                          path="/InvoicesPage"
                          component={InvoicesPage}
                        />
                        <PrivateRoutes path="/cover" component={Cover} />
                        <PrivateRoutes
                          path="/Businesses"
                          component={Businesses}
                        />

                        <PrivateRoutes
                          path="/PdfDisplay"
                          component={PdfDisplay}
                        />
                        <PrivateRoutes
                          path="/NotesMenuPage"
                          component={NotesMenuPage}
                        />

                        <PrivateRoutes
                          path="/NotesMenu"
                          component={NotesMenuPage}
                        />
                        <PrivateRoutes
                          path="/NoteSelected"
                          component={NoteSelected}
                        />

                        <PrivateRoutes
                          path="/MaterialUIModal"
                          component={TransitionsModal}
                        />
                        <PrivateRoutes path="/TBalance" component={TBalance} />
                        <PrivateRoutes
                          path="/OpeningBalances"
                          component={OpeningBalances}
                        />
                        <PrivateRoutes
                          path="/MigrationOnboarding"
                          component={MigrationOnboarding}
                        />
                        <PrivateRoutes path="/Support" component={Support} />
                        <PrivateRoutes
                          path="/AdminChat"
                          component={AdminChat}
                        />
                        <PrivateRoutes
                          path="/AdminUpdates"
                          component={AdminUpdates}
                        />
                        <PrivateRoutes
                          path="/Updates"
                          component={UpdatesPage}
                        />
                        <Route path="/ChatDemo" component={ChatDemo} />
                        <PrivateRoutes path="/ShortCut" component={ShortCut} />
                        <PrivateRoutes
                          path="/ExtractData"
                          component={ExtractData}
                        />
                        <PrivateRoutes
                          path="/Ledger"
                          component={LedgerAdvanced}
                        />

                        {/* 🧪 TESTING ROUTES: Remove these after testing */}
                        <PrivateRoutes
                          path="/ledger-tester"
                          component={LedgerTester}
                        />
                        <PrivateRoutes
                          path="/ledger-simple"
                          component={LedgerSimple}
                        />
                        <PrivateRoutes
                          path="/ledger-advanced"
                          component={LedgerAdvanced}
                        />
                        <PrivateRoutes
                          path="/health-check"
                          component={SystemHealthCheck}
                        />

                        <PrivateRoutes
                          path="/TaxNavigation"
                          component={TaxNavigation}
                        />
                        <PrivateRoutes
                          path="/VatCalculation"
                          component={VatCalculation}
                        />
                        <PrivateRoutes
                          path="/DeveloperPortal"
                          component={DeveloperPortal}
                        />

                        <PrivateRoutes
                          path="/report.jsx"
                          component={AccountantsReport}
                        />

                        <PrivateRoutes
                          path="/settings"
                          component={SettingsFile}
                        />
                        <PrivateRoutes
                          path="/CompliancePortal"
                          component={CompliancePortal}
                        />
                        <PrivateRoutes
                          path="/contents.jsx"
                          component={Contents}
                        />
                        <PrivateRoutes
                          path="/UserProfile"
                          component={UserProfile}
                        />
                        <PrivateRoutes
                          path="/AuditLogs"
                          component={AuditLogs}
                        />
                        <PrivateRoutes
                          path="/bankUpdate"
                          component={BankUpdate}
                        />
                        <PrivateRoutes path="/TaxCalc" component={TaxCalc} />
                        <PrivateRoutes
                          path="/AddEmployee"
                          component={AddEmployee}
                        />
                        <PrivateRoutes
                          path="/ExportData"
                          component={ExportData}
                        />
                        <PrivateRoutes
                          path="/EmployerDetails"
                          component={EmployerDetails}
                        />
                        <PrivateRoutes
                          path="/AutomateAccount"
                          component={AutomateAccount}
                        />
                        <PrivateRoutes path="/Payment" component={Payments} />
                        <PrivateRoutes
                          path="/TBalanceOptimized"
                          component={TBalanceOptimized}
                        />
                        <PrivateRoutes
                          path="/PayrollTotal"
                          component={PayrollTotal}
                        />
                        <PrivateRoutes
                          path="/PayrollDashboard"
                          component={PayrollDashboard}
                        />
                        <PrivateRoutes
                          path="/leave-management"
                          component={LeaveManagement}
                        />
                        <PrivateRoutes
                          path="/emp201-report"
                          component={EMP201Report}
                        />
                        <Route
                          path="/employee-portal"
                          component={EmployeePortal}
                        />
                        <PrivateRoutes path="/Invoices" component={Invoices} />
                        <PrivateRoutes
                          path="/customer-aging-report"
                          component={CustomerAgingReport}
                        />
                        <PrivateRoutes
                          path="/supplier-aging-report"
                          component={SupplierAgingReport}
                        />
                        <PrivateRoutes
                          path="/AddBusiness"
                          component={AddBusiness}
                        />
                        <PrivateRoutes path="/Tutorial" component={TutorialNew} />
                        <PrivateRoutes
                          path="/TutorialNew"
                          component={TutorialNew}
                        />
                        <PrivateRoutes
                          path="/TutorialLegacy"
                          component={Tutorial}
                        />
                        <PrivateRoutes
                          path="/InvoicesAdded"
                          component={InvoicesAdded}
                        />
                        <PrivateRoutes
                          path="/InvoiceSummary"
                          component={InvoiceSummary}
                        />
                        <PrivateRoutes
                          path="/AddProduct"
                          component={AddProduct}
                        />
                        <PrivateRoutes
                          path="/ProductsAdded"
                          component={ProductsAdded}
                        />
                        <PrivateRoutes
                          path="/inventory-management"
                          component={InventoryManagement}
                        />
                        <PrivateRoutes
                          path="/error-test"
                          component={ErrorHandlingTest}
                        />
                        <PrivateRoutes
                          path="/Dashboard"
                          component={Dashboard}
                        />
                        <PrivateRoutes path="/Budget" component={Budget} />
                        <Route
                          path="/InvoicePayment"
                          component={InvoicePayment}
                        />
                        <Route
                          path="/EngagementPortal"
                          component={EngagementPortal}
                        />
                        <PrivateRoutes
                          path="/EngagementLetters"
                          component={EngagementLetters}
                        />
                        <PrivateRoutes
                          path="/InvestecAPI"
                          component={InvestecAPI}
                        />
                        <PrivateRoutes
                          path="/BulkImport"
                          component={BulkImport}
                        />
                        <PrivateRoutes
                          path="/AccountingSoftwareImport"
                          component={AccountingSoftwareImport}
                        />
                        <PrivateRoutes path="/Internal" component={Internal} />
                        <PrivateRoutes path="/Tasks" component={Tasks} />
                        <PrivateRoutes
                          path="/TasksPage"
                          component={TasksPage}
                        />
                        <PrivateRoutes
                          path="/TasksDetails"
                          component={TasksDetails}
                        />
                        <PrivateRoutes
                          path="/TasksAdded"
                          component={TasksAdded}
                        />
                        <PrivateRoutes
                          path="/ProvTaxCalc"
                          component={ProvTaxCalc}
                        />
                        <PrivateRoutes
                          path="/AssetRegister"
                          component={AssetRegister}
                        />
                        <PrivateRoutes
                          path="/AuditPortal"
                          component={AuditPortal}
                        />
                        <PrivateRoutes
                          path="/TaskSummary"
                          component={TaskSummary}
                        />
                        <PrivateRoutes
                          path="/CIPCTracking"
                          component={CIPCTracking}
                        />
                        <PrivateRoutes
                          path="/UploadProducts"
                          component={UploadProducts}
                        />
                        <Route path="/FeedBack" component={FeedBack}></Route>
                        <Route
                          path="/feedbackpage"
                          component={FeedbackPage}
                        ></Route>
                        <Route path="/Admin" component={Admin}></Route>
                        <Route path="/AdminInfo" component={AdminInfo}></Route>
                        <PrivateRoutes
                          path="/AdminDashboard"
                          component={AdminDashboard}
                        />
                        <PrivateRoutes
                          path="/ClientMessages"
                          component={ClientMessages}
                        />
                        <Route
                          path="/ResetPasscode"
                          component={ResetPasscode}
                        />
                        <PrivateRoutes
                          path="/ClientCollaboration"
                          component={ClientCollaboration}
                        />
                        {/* this is for pages that are not found - not in routes , etc, must be after other routes and no path is given */}
                      </ErrorBoundary>{" "}
                      <Route component={PageNotFound} />
                    </Switch>
                  </Suspense>
                </ReRoute>
                {/* Live Chat Widget - Available on all pages */}
                <ChatWrapper />
                {/* Cookie Consent Banner */}
                <CookieBanner />
              </FirebaseAuth>
            </header>
          </div>
        </Router1>
      </TransactionProvider>
    </OnlineStatusProvider>
  );
}

export default App;
